import React from "react";

import gears from "./gears.gif";
import styles from "./Gears.module.scss";

export interface IGearsProps {
  style?: React.CSSProperties;
}

export const Gears: React.FC<IGearsProps> = ({ style }) => {
  return (
    <div className={styles.base}>
      <img src={gears} style={style} alt="gears-spinner" />
    </div>
  );
};
